import { Dispatch, MiddlewareAPI, UnknownAction } from '@reduxjs/toolkit'
import { GenerationStatusEnum } from '@repo/shared/events/generation'

import { RootState } from '@/store'
import { storeActions } from '@/store/actions'
import { AssistantFeedItem } from '@/store/assistant'
import { ISocket } from '@/store/middlewares/types'

export const initHandleSocketAction =
  ({
    store,
    UseSocket,
  }: {
    store: MiddlewareAPI<Dispatch<UnknownAction>, RootState>
    UseSocket: ISocket
  }) =>
  <T extends { generationId: string } & Record<string, unknown>>({
    key,
    emitPayload,
    endAction,
    onItemReceived = storeActions.assistant.add.feed.item,
  }: {
    key: string
    emitPayload: T
    endAction: (p: T) => void
    onItemReceived?: (p: { item: AssistantFeedItem }) => void
  }) => {
    if (emitPayload.generationId !== store.getState().assistant.generationId)
      return store.dispatch(endAction(emitPayload) as unknown as UnknownAction)

    // Emit the event to the server
    UseSocket.emit(key, emitPayload)

    // Listen for the response from the server
    UseSocket.listen(key, (v) => {
      const generationId = store.getState().assistant.generationId
      if (!generationId || v.generationId !== generationId)
        return store.dispatch(endAction(emitPayload) as unknown as UnknownAction)

      if (v.status === GenerationStatusEnum.Finished)
        store.dispatch(endAction(emitPayload) as unknown as UnknownAction)

      if (!v.payload) return console.info('Socket Event without payload:', v)

      store.dispatch(onItemReceived({ item: v.payload }) as unknown as UnknownAction)
    })
  }
